const hasText = (value) => String(value || '').trim() !== '';

export const chooseMainProductForMerge = (group) => {
  const productsWithItemNumber = group.filter(product => hasText(product.itemNumber));
  const candidates = productsWithItemNumber.length > 0 ? productsWithItemNumber : group;

  let mainProduct = candidates.find(product => (
    hasText(product.weight) && String(product.weight).trim() !== '0'
  ));

  if (!mainProduct) {
    mainProduct = candidates.find(product => (
      hasText(product.costTWD)
      || hasText(product.costKoreanWon)
      || hasText(product.costJPY)
      || hasText(product.costTHB)
    ));
  }

  return mainProduct || candidates[0];
};

export const hasConflictingItemNumbers = (group) => {
  const itemNumbers = new Set(
    group
      .map(product => String(product.itemNumber || '').trim().toUpperCase())
      .filter(Boolean)
  );
  return itemNumbers.size > 1;
};

const FALLBACK_FIELDS = [
  'weight',
  'costTWD',
  'costKoreanWon',
  'costJPY',
  'costTHB',
  'costRMB',
  'costType',
  'livePrice',
  'onlinePrice',
  'vendor',
  'image',
  'remarks',
];

export const fillMissingProductFields = (mainProduct, mergeCandidates) => {
  const mergedProduct = { ...mainProduct };

  mergeCandidates.forEach(candidate => {
    FALLBACK_FIELDS.forEach(field => {
      if (!hasText(mergedProduct[field]) && hasText(candidate[field])) {
        mergedProduct[field] = candidate[field];
      }
    });

    if ((!mergedProduct.photos || mergedProduct.photos.length === 0)
      && candidate.photos?.length > 0) {
      mergedProduct.photos = candidate.photos;
    }
  });

  return mergedProduct;
};
